import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

type Props = {
  size?: number;
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

export const ButtonLoading = ({ size = 18, color = 'inherit' }: Props) => {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={size} color={color} />
    </Box>
  );
};
